import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import { client } from '../client'
import emptyDrink from '../images/emptyDrink2.svg'
import { IoCloseOutline } from "react-icons/io5";

const DrinksMenu = ({ isEng, isFood,closePromoBanner, products, selectedCat, setSelectedCat, categories,searchStarted,setSearchDrinkObjectHandler,handleSearch, searchDrinkObject  }) => {

   

    function filterProducts(prods) {
        
            if (searchDrinkObject !== '') {
               
    
                 let produkts = prods.filter((a) => {
                   
                  return  (
                    a.title.toLowerCase().includes(searchDrinkObject.toLowerCase())
                  )
            })
                let bodyProdukts = prods.filter((a)=>{
                   return (!a.title.toLowerCase().includes(searchDrinkObject.toLowerCase()) && (a.body !== null && a.body.toLowerCase().includes(searchDrinkObject.toLowerCase())));
                })
                produkts = [...produkts, ...bodyProdukts]
                produkts.sort((a, b) => {
                  return  a.title.toLowerCase().includes(searchDrinkObject.toLowerCase()) > !a.title.toLowerCase().includes(searchDrinkObject.toLowerCase()) ? -1 : 1
                })
                return produkts;
            }
              
                
         else {
            let filteredData = []
            for (let prod of prods) {
                if (prod.drinksCategory?.title === selectedCat) {
                    prod.publishedAt = new Date(prod.publishedAt);
                    filteredData.push(prod)
                }
            }
            filteredData = filteredData.sort((a,b) => b?.publishedAt - a?.publishedAt)
          
            return filteredData
        }

    }
    let filteredProducts = []
    if (products !== null) {
        filteredProducts = filterProducts(products)
    }


    return (
        <AnimatePresence>
            {!isFood &&
                <motion.div
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -300, opacity: 0 }}
                     className='w-full m-auto mb-[80px] text-center leading-[1rem] '>
                    <div className='relative categories text-mainTwo flex flex-row justify-center mb-2  '>
                        {/* <h1 className='absolute top-0 left-6 sm:left-14 md:left-40 sm:text-2xl text-xl font-bold'>
                            {!isEng ? "Изберете категория:" : "Category"}</h1>
                        <div
                            onClick={() => { setSelectedCat('') }}
                            className={`cursor-pointer w-1/4 rounded-md flex items-center  justify-center ${selectedCat === '' ? 'bg-mainThree text-mainOne text-lg'
                                : ' bg-mainOne text-mainTwo'}  text-center italic p-1   text-base `}>
                            <p>{!isEng ? "Всички" : "All"}</p>
                        </div> */}
                    </div>
                    {/* Category picker */}
                    <div className='w-full flex flex-wrap gap-y-[0.3rem] gap-x-[1px] justify-around mt-1 text-lg  font-bold'>
                        {searchStarted &&  <AnimatePresence>
                                    <motion.div
                                    className="flex flex-row"
                                        initial={{ x: -300, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: 300, opacity: 0 }}>
                                           
                                        <div classname=" flex-row w-3/4 flex-nowrap">
                                            <label for="Search" class="sr-only"> Search </label>

                                            <input
                                                type="text"
                                                id="Search"
                                                placeholder="Пийва ми се..."
                                                value={searchDrinkObject}
                                                onChange={(e) => {
                                                    setSearchDrinkObjectHandler(e.target.value)
                                                    
                                                }}

                                                class="pl-2 w-full rounded-md border-gray-200 py-2.5 pe-10 shadow-sm sm:text-sm"
                                            />
                                                
                                            <span class="absolute inset-y-0 end-0 grid w-10 place-content-center">
                                                <button type="button" class="text-gray-600 hover:text-gray-700">
                                                    <span class="sr-only">Search</span>
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                                    />

                                                </button>
                                               
                                            </span>
                                           
                                        </div>
                                        <motion.div
                                        className='m-auto z-[100]'
                                        whileTap={{rotate: 360}}
                                        transition={{type:"spring"}}
                                        >
                                        <IoCloseOutline 
                                        onClick={(е)=> {                                          
                                            setSearchDrinkObjectHandler('')
                                            handleSearch()
                                            
                                        }}
                                         size={35} className='z-50000' />
                                        </motion.div>
                                    </motion.div>

                                </AnimatePresence>}
                        {!searchStarted && categories && categories.map(category =>
                        
                        <AnimatePresence>
                        <motion.div
                            initial={{ x: -300, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: 300, opacity: 0 }}

                            onClick={() => {
                                closePromoBanner()
                                setSelectedCat(category.title)
                            }}
                            key={category.importance}
                            className={`cursor-pointer w-1/5 rounded-md font-categories mt-1 z-10 flex items-center justify-center leading-[1rem]  text-base h-[40px]
                       
                        ${selectedCat === category.title
                                    ? ' bg-mainThree text-mainOne ' : 'bg-mainOne text-mainTwo'}  text-center italic p-1 `}>
                            <p>{category.title}</p>
                        </motion.div>
                    </AnimatePresence>
                           )}


                    </div>
                    {/* SHOWCASE */}
                    <div className='w-11/12 m-auto mt-6 sm:flex sm:flex-wrap sm:flex-row text-center'>
                        {/* EACH PRODUCT */}
                     
                            {!searchStarted && filteredProducts.length === 0 &&
                            <p className='text-mainThree text-xl italic w-1/2 m-auto mt-10'>
                                {!isEng ? "За съжаление нямаме налични продукти от тази категория в момента." : "We are loading..."}
                            </p>}
                            {searchStarted && filteredProducts.length === 0 &&
                            <p className='text-mainThree text-xl italic w-1/2 m-auto mt-10'>
                                {!isEng ? "Нямаме продукти, които отговарят на това търсене ..." : "We dont have any products meeting this criteria..."}
                            </p>}
                        {filteredProducts && filteredProducts.map(product =>

                            <div key={product.slug.current} className='flex flex-col  border-b-0 h-[380px] w-full sm:w-1/2  lg:w-1/3 '>
                                <div className='border  border-black border-b-0 h-[320px] border-opacity-60 text-mainTwo overflow-hidden'>
                                    <div className='h-[320px] w-full overflow-hidden  border-black'>
                                        <motion.img
                                            initial={{ scale: 0.7 }}
                                            whileInView={{ scale: 1 }}
                                            whileTap={{ scale: 1.5 }}
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ duration: 0.3 }}
                                            className=' object-contain  w-full p-2 h-full' src={(product.mainImage?.asset?.url &&                                               
                                                    product.mainImage?.asset?.url +'?auto=format&w=1200') || emptyDrink}>

                                        </motion.img>
                                    </div>
                                </div>
                                {/* TITLE AND DESCRIPTION */}
                                <div className='border  border-t-0 pb-3   border-black border-opacity-60 text-mainThree overflow-hidden'>
                                    <div className='z- w-full p-[1px] self-start ml-2 text-xl flex justify-around items-center'>
                                        <div className='w-9/12 flex flex-col'>
                                            <h1 className=' font-drinks-title'>{!isEng ? product?.title : product.title_eng}
                                                {product.weight && `- ${product?.weight}${!isEng ? "мл." : "ml."}`}</h1>
                                            {/* DESCRIPTION */}
                                            <div className='prose flex flex-col italic justify-start items-start ml-4 text-xl'>
                                        
                                                <div className=''>
                                                    <p className='mb-8'>{ product.body ? product.body : ''}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='h-[50px] w-[50px] mr-2 border border-[#2a5d80] rounded-full bg-mainOne flex flex-col justify-center items-center'>
                                            <p className='font-price'>{product?.price}{!isEng ? "лв." : "bgn."}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt-6 font-end-of-category italic pb-4 text-mainTwo'>
                        {filteredProducts.length !== 0 &&
                            <h1>{!isEng ? "Достигнахте до края на тази категория" : "You reached the end of this category"} </h1>}

                    </div>
                </motion.div>}
        </AnimatePresence>
    )
}

export default DrinksMenu